import React from "react";

const LeftContent = () => {
    return <div className="left_item">
        <img width="150" src="/images/logo.svg" alt="" />
        <h3>A Better Solution to Food Management</h3>
        <img className="public-image-login" src="/images/public_img.png" alt="" />
    </div>
};
export default LeftContent;